import React from 'react'

import { ReactComponent as plus } from 'shared/assets/icons/add_sign.svg'
import { ReactComponent as arrow_narrow_left } from 'shared/assets/icons/arrow-narrow-left.svg'
import { ReactComponent as refresh } from 'shared/assets/icons/refresh.svg'
import { theme } from 'shared/styles/theme'

import { ReactComponent as home } from './icons/home-02.svg'
import { ReactComponent as map } from './icons/map-02.svg'
import { ReactComponent as printer } from './icons/printer.svg'
import { ReactComponent as redo } from './icons/redo-01.svg'
import { ReactComponent as save } from './icons/save-01.svg'
import { ReactComponent as undo } from './icons/undo-01.svg'
import { ReactComponent as upload } from './icons/upload-01.svg'
import { ReactComponent as user } from './icons/user-03.svg'

export const iconSet = {
  general: [
    'arrow_narrow_left',
    'plus',
    'refresh',
    'home',
    'map',
    'user',
    'save',
    'upload',
    'printer',
    'undo',
    'redo'
  ]
} as const

export type IconName = typeof iconSet['general'][number]

const svgIconMap: {
  [key in IconName]: React.FC<React.SVGProps<SVGSVGElement>>
} = {
  arrow_narrow_left: arrow_narrow_left,
  plus: plus,
  refresh,
  home,
  map,
  user,
  save,
  upload,
  printer,
  undo,
  redo
}

export interface IconProps {
  testID?: string
  name: IconName
  size?: number
  color?: string
  fill?: string
  strokeFill?: string
}

const Icon: React.FC<IconProps> = ({
  name,
  color = theme.color.base.c9,
  fill = 'none',
  size = 24
}) => {
  const SvgIcon = svgIconMap[name]

  return (
    <SvgIcon width={size} height={size} color={color} fill={fill} />
  )
}

export default Icon
